// 基础数据
const basicData = {
    // 任务状态信息 -- 运输任务
    taskStatus:[
        {
            value: '0',
            label: '新建'
        }, {
            value: '1',
            label: '发布'
        }, {
            value: '2',
            label: '接单'
        }, {
            value: '3',
            label: '完成'
        }, 
        {
            value: '4',
            label: '审核'
        },{
            value: '5',
            label: '退回'
        },{
            value: '-1',
            label: '取消'
        },
    ],
    // 任务类型
    taskType:[
        {
            value: '0',
            label: '进口'
        }, {
            value: '1',
            label: '出口'
        }, {
            value: '2',
            label: '调拨'
        },{
            value: '3',
            label: '配货'
        }
    ],
    // 入库方式
    inStorageType:[
        {
            value: '0',
            label: '采购入库'
        }, {
            value: '1',
            label: '盘点入库'
        }, {
            value: '2',
            label: '其他'
        }
    ],
    // 出库方式
    outStorageType:[
        {
            value: '0',
            label: '领出'
        }, {
            value: '1',
            label: '销毁'
        }, {
            value: '2',
            label: '转出'
        }
    ],
}
export default basicData